module.exports = __webpack_public_path__ + "img/Beneficio_1.e5f3adb3.webp";